import React, { useEffect } from 'react';
import VideoHero from '../components/ai-video/VideoHero';
import VideoWhy from '../components/ai-video/VideoWhy';
import VideoServices from '../components/ai-video/VideoServices';
import VideoAdvertSection from '../components/ai-video/VideoAdvertSection';
import PodcastSection from '../components/ai-video/PodcastSection';
import VideoProcess from '../components/ai-video/VideoProcess';
import VideoIndustries from '../components/ai-video/VideoIndustries';
import VideoFAQ from '../components/ai-video/VideoFAQ';
import ContactCTA from '../components/ContactCTA';

const AIVideoService = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "AI Video Creation Service | Professional Video Ads & Podcasts | DigitalGigs";
  }, []);

  return (
    <div className="bg-white">
      <VideoHero />
      <VideoWhy />
      <VideoServices />
      <VideoAdvertSection />
      <PodcastSection />
      <VideoIndustries />
      <VideoProcess />
      <VideoFAQ />
      <ContactCTA />
    </div>
  );
};

export default AIVideoService;
